import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  inject,
  OnInit,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ProgressSpinner } from 'primeng/progressspinner';
import { FormUpdateLoadingService } from 'src/app/services/app/form-update-loading.service';

@Component({
  standalone: true,
  selector: 'app-form-update-loading-overlay',
  templateUrl: './form-update-loading-overlay.component.html',
  styleUrl: './form-update-loading-overlay.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProgressSpinner],
})
export class FormUpdateLoadingOverlayComponent implements OnInit {
  private readonly loader = inject(FormUpdateLoadingService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  visible = false;

  ngOnInit(): void {
    this.loader.loading$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((loading) => {
        this.visible = loading;
        this.cdr.markForCheck();
      });
  }
}
